<template>
    <div class="time-tracked-modal-comp">
        <div class="small-block">
            <label class="select-label">Since:</label>
            <div class="select-holder">
                <VSelect 
                    :options="sinceOptions"
                    value="id"
                    title="title"
                    :setDefaultValue="sinceSelected"
                    @selectHandler="saveSinceValue"
                    :key="sinceSelected"
                />
                <i class="icon-arrow-down-small"></i>
            </div>
        </div>
        <div class="small-block">
            <label class="select-label">User:</label>
            <div class="select-holder">
                <VSelect 
                    :options="users"
                    value="id"
                    title="username"
                    :setDefaultValue="userSelected"
                    @selectHandler="saveSelectedUser"
                    :key="userSelected"
                />
                <i class="icon-arrow-down-small"></i>
            </div>
        </div>
        <table class="time-table">
            <thead>
                <tr>
                    <th>Project</th>
                    <th>Task</th>
                    <th>Time</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="detail in loggedWorkEvents">
                    <td>{{ detail['project_id'] }}</td>
                    <td>{{ detail['task_id'] }}</td>
                    <td>{{ convertTimeToHMSystem(detail['minutes']) }}</td>
                </tr>
                <tr class="total-tr">
                    <th>Total</th>
                    <th></th>
                    <th>{{ convertTimeToHMSystem(totaltime) }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import {api} from "@/mixins/axios";
import {applyDrag, difference} from "@/mixins/helpers";
import Flash from "@/components/Flash.vue";
import VSelect from "@/components/atoms/VSelect.vue";
import VButton from "@/components/atoms/VButton";
import {mapGetters, mapMutations, mapState} from 'vuex';
import Dropmenu from "@/components/atoms/Dropmenu.vue";

export default {
    name: "TimeTrackerModal",
    components: {
        VButton,
        Flash,
        Dropmenu,
        VSelect,
    },
    props: ['timeRegisteredToday', 'tags'],
    data: function () {
        return {
            sinceOptions: [
                {id: '6_hours', title: 'Last 6 hours', hours: 6},
                {id: '12_hours', title: 'Last 12 hours', hours: 12},
                {id: '24_hours', title: 'Last 24 hours', hours: 24},
                {id: '7_days', title: 'Last 7 days', hours: 168},
            ],
            sinceSelected: '6_hours',
            loggedWorkEvents: [],
            allLoggedWorkEvents: [],
            totaltime: 0,
            userSelected: this.currentUser?.id
        };
    },
    computed: {
        task() {
            return this.$store.getters.editableTask
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        users() {
            return this.$store.getters.users
        },
        boards() {
            return this.$store.getters.boards
        },
        activeBoardTasks() {
            return this.$store.getters.activeBoardTasks
        },
    },
    async mounted() {
        if(this.currentUser) {
            this.userSelected = this.currentUser.id
        }
        if (this.task.events && this.task.events.length > 0) {
            this.getCorrectTime(this.task.events)
        }
    },
    async created() {
    },
    methods: {
        saveSinceValue(val) {
            this.sinceSelected = val

            this.showDataPerUser()
        },
        showDataPerTime() {
            let currentDate = new Date()
            let hours = this.sinceOptions.find(o => o.id == this.sinceSelected).hours
            let startCountDate = new Date(currentDate)
            startCountDate.setHours(startCountDate.getHours() - hours);

            this.loggedWorkEvents = this.allLoggedWorkEvents.filter(item => {
                return new Date(item.created * 1000) >= startCountDate
            });
        },
        formatTitleLength(title) {
            if (title.length > 6) {
                return `${title.substring(0, 6).trim()}...`
            } else {
                return title
            }
        },
        convertTimeToHMSystem(min, unit) {
            const decimalHours = min / 60;
            const hours = Math.floor(decimalHours);
            const minutes = min % 60;

            if (unit === 'm') {
                return minutes;
            } else if (unit === 'h') {
                return hours;
            } else {
                return `${hours}h ${minutes}m`;
            }
        },
        totalHoursToday() {
            let total = 0
            this.timeRegisteredToday.forEach(time => total += time.minutes)
            return this.convertTimeToHMSystem(total)
        },
        getCorrectTime(events) {
            const mergedData = {};
            let tasks = this.activeBoardTasks.map(t => t.tasks).flat();
            events.forEach(item => {
                if (item.type === 'logwork') {
                    const userId = item.user_id;
                    if (!mergedData[userId]) {
                        mergedData[userId] = {
                            created: item.created,
                            project_id: this.boards.find(b => b.id == item.project_id)?.title || 'Undefined project',
                            task_id: tasks.find(t => t.id == item.task_id)?.title || 'Undefined task',
                            name: item.type,
                            minutes: item.uint1,
                            user: { id: item.user_id, username: this.getEventUser(item)['username'], email: this.getEventUser(item)['email'], portrait: this.getEventUser(item)['portrait'] },
                        };
                    } else {
                        mergedData[userId].minutes += item.uint1;
                    }
                }
            });
            this.loggedWorkEvents = Object.values(mergedData);
            this.allLoggedWorkEvents = Object.values(mergedData);
            
            this.totaltime = this.loggedWorkEvents.reduce((a, b) => a + b.minutes, 0)
            this.showDataPerTime()
        },
        getEventUser(event) {
            return this.tags?.find(t => t.id == event.user_id) || {}
        },
        saveSelectedUser(val) {
            this.userSelected = val

            this.loggedWorkEvents = this.allLoggedWorkEvents.filter(e => e.user.id == val)
            this.showDataPerTime()
        },
        showDataPerUser() {
            this.loggedWorkEvents = this.allLoggedWorkEvents.filter(e => e.user.id == val)
            this.showDataPerTime()
        }
    },
    watch: {
        'task.events': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.getCorrectTime(newVal)
                }
            },
            deep: true
        }
    },
};
</script>

<style lang="scss">
.time-tracked-modal-comp {
	.select-holder {
        position: relative;
		margin-bottom: 17px;
        min-width: 120px;

        & > i {
            font-size: 6px;
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
        }

        .custom-select {
            border-radius: 10px;
            border-color: var(--outline);
			font-size: 14px;
        }

		.select-selected {
			padding: 3px 20px 3px 10px;
		}
    }

    .select-label {
        display: block;
        margin-bottom: 5px;
    }

	.small-block {
		max-width: 200px;
		margin-right: 15px;
        display: flex;
        gap: 10px;
	}
}

.time-table {
    outline: 1px solid #3E3E3E;
    width: 100%;
    border-radius: 6px;
    margin-top: 10px;

    thead { border-bottom: 1px solid #3E3E3E; }

    .total-tr { border-top: 1px solid #3E3E3E; }

    th, td { padding: 6px; }
}
</style>
